import { render, staticRenderFns } from "./ModalIdleWarning.vue?vue&type=template&id=c5e1fa6a"
import script from "./ModalIdleWarning.vue?vue&type=script&lang=js"
export * from "./ModalIdleWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports